

/**
 * @name AddAppointmentController
 * @description Controller called by the add project component.
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 */
function AddAppointmentController(
  _,
  $log
) {
  let vm = this;
  vm.newAppointment = {};
  vm.selectArtist = selectArtist;

  vm.$onInit = function() {
    vm.steps = [
      {
        id: 1,
        name: 'selectArtist',
        description: 'Select an artist'
      },
      {
        id: 3,
        name: 'addProject',
        description: 'Add a project'
      },
      {
        id: 4,
        name: 'selectFavoriteWork',
        description: 'Choose your favorites'
      },
      {
        id: 5,
        name: 'confirmation',
        description: 'You’re all set!'
      }
    ];
    vm.activeStep = _.find(vm.steps, {name: 'selectArtist'});
  };

  /**
   * @name selectArtist
   * @description Function to select the artist and move to the next step in the process
   * @param {object} artist The selected artist
   */
  function selectArtist(artist) {
    vm.newAppointment.artist = artist;
    vm.activeStep = _.find(vm.steps, {name: 'addProject'});
    $log.debug('Active step: ', vm.activeStep);
  }
}

angular
  .module('inkfinder')
  .controller('AddAppointmentController', AddAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/add/add-appointment.controller.js